import { render, staticRenderFns } from "./EdgecasterEncoders.vue?vue&type=template&id=f89e5d9c"
import script from "./EdgecasterEncoders.vue?vue&type=script&lang=js"
export * from "./EdgecasterEncoders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports